import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import SetTitle from '../components/shared/SetTitle';
import TypeOfPersonSelect from '../components/shared/TypeOfPersonSelect';
import HelpText from '../components/help/HelpText';

import { adminUser, managerUser, setIdAndMethod, renderErrors } from '../utilities/Forms.js'
import { formatDate, debounce, STAFF_TYPE_OF_PEOPLE } from '../utilities/Generic.js'

import Audits from '../components/shared/Audits';

class HolidayForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  state = {
    name: "",
    start_date: formatDate(new Date(), 0),
    end_date: formatDate(new Date(), 0),
    half_day_work_at_start: false,
    half_day_work_at_end: false,
    type_of_person: "",
    partial: "",
    person_id: "",
    people: [],

    loaded: false,
    peopleLoaded: true,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    this.setState({[name]: value});
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleTypeChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    this.handlePersonSearch(this.state.partial, value)
  }

  handlePersonSearch(partial, type_of_person) {
    if (partial.trim() === "") {
      this.setState({ peopleLoaded: true });
      return
    }

    let params = `person[location]=${this.props.location_id}&person[partial]=${partial}`

    if (type_of_person !== "") {
      params += `&person[type][]=${type_of_person}`
    }

    request('GET', `/v1/a/people/scoped_names_and_ids?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, peopleLoaded: true })
      })
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      peopleLoaded: false
    });

    this.debouncedHandlePersonSearch(value, this.state.type_of_person)

    event.preventDefault()
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = JSON.stringify({
      "staff_holiday": {
        "person_id": this.props.person_id || this.state.person_id,
        "start_date": this.state.start_date,
        "end_date": this.state.end_date,
        "half_day_work_at_start": this.state.half_day_work_at_start,
        "half_day_work_at_end": this.state.half_day_work_at_end
      }
    })

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/staff_holidays/${id}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Holiday ${this.props.mode}d successfully!`);

        this.props.closePanel()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  handleDelete(event) {
    this.setState({ updating: true })

    request("DELETE", `/v1/a/staff_holidays/${this.props.id}`, "", () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Holiday deleted successfully!`);

        this.props.closePanel()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderDeleteButton() {
    if (adminUser() || managerUser()) {
      if (this.props.mode === "update") {
        return <div className="button float-right red-button" onClick={this.handleDelete}>Delete</div>
      }
    }
  }

  render() {
    const { name, start_date, end_date, loaded, id, redirect, unauthorized, errors, error, type_of_person, partial, person_id, peopleLoaded, people, half_day_work_at_start, half_day_work_at_end } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/people/${this.props.person_id}`}/>
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    const title = this.props.mode === "create" ? "New" : "Edit"
    const formatName = name ? ` ${name} |` : ""

    return (
      <div>
        <SetTitle title={`${title} Holiday |${formatName} Holidays`} />

        <form onSubmit={this.handleSubmit}>
          <div className="settings big-settings">
            { renderErrors(errors, 'person') }

            { !this.props.person_id && (
              <div className="row bottom-margin">
                <label className="column">Select Person:</label>
                <TypeOfPersonSelect className="small-bottom-margin" defaultText="Filter by Person Type" value={type_of_person} onChange={this.handleTypeChange} options={STAFF_TYPE_OF_PEOPLE} />

                <input name="partial" placeholder="Enter text to search" className="no-margin" onChange={this.handlePartialChange} value={partial} />
                <select name="person_id" className="no-margin" onChange={this.handleChange} value={person_id}>
                  <option value="">{peopleLoaded ? `Select a Person (${this.state.people.length})` : "Loading..."}</option>
                  {people.map((person) => (
                    <option value={person.id} key={person.id} disabled={this.props.person_id === person.id}> {person.full_name}</option>
                  ))}
                </select>
              </div>
            )}

            { this.props.person_name && (
              <div className="row">
                <label className="column">Person:</label>
                <input type="text" name="person_name" value={this.props.person_name} disabled />
              </div>
            )}

            <div className="row">
              <label className="column">Start Date:</label>{ renderErrors(errors, 'start_date') }
              <HelpText className="inline" page={'staff_holidays'} section={'start_date'} />

              <input type="date" name="start_date" onChange={this.handleChange} value={start_date} />
            </div>
            <div className="row">
              <label className="column">End Date:</label>{ renderErrors(errors, 'end_date') }
              <HelpText className="inline" page={'staff_holidays'} section={'end_date'} />

              <input type="date" name="end_date" onChange={this.handleChange} value={end_date} />
            </div>

            <div className="half-row center">
              <div className="row">
                <HelpText className="inline" page={'staff_holidays'} section={'half_day_work_at_start'} />
                <label className="checkbox-label" htmlFor="half_day_work_at_start">Half day of work at start</label>
              </div>
              <div className="row">
                <HelpText className="inline" page={'staff_holidays'} section={'half_day_work_at_end'} />
                <label className="checkbox-label" htmlFor="half_day_work_at_end">Half day of work at end</label>
              </div>
            </div>

            <div className="half-row center">
              <div className="row">
                <input className="column" type="checkbox" name="half_day_work_at_start" checked={half_day_work_at_start} onChange={this.handleCheckbox} />
              </div>
              <div className="row">
                <input className="column" type="checkbox" name="half_day_work_at_end" checked={half_day_work_at_end} onChange={this.handleCheckbox} />
              </div>
            </div>
            { renderErrors(errors, 'half_day_work_at_start' , "") }
            { renderErrors(errors, 'half_day_work_at_end', "") }
          </div>

          <div className="settings big-settings">
            { this.renderSaveButton() }
            { this.renderDeleteButton() }
          </div>
        </form>

        { this.props.mode === "update" && <Audits klass="StaffHoliday" id={this.props.id} /> }
      </div>
    );
  }

  componentDidMount() {
    let id = this.props.id;

    if (this.props.mode === "update") {
      request('GET', `/v1/a/staff_holidays/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            start_date: data.start_date,
            end_date: data.end_date,
            half_day_work_at_start: data.half_day_work_at_start,
            half_day_work_at_end: data.half_day_work_at_end,
            loaded: true
          })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }
    else {
      this.setState({ loaded: true })
    }
  }
}

export default HolidayForm;
